(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lv-card-hover"] && !Shopify.designMode) return;
  try {
    (function () {
    // Kaartfoto's wisselen (Jens, 23 okt 2026). Een keer per pagina, alles via delegation.
    if (window.__lvCh) return;
    window.__lvCh = true;

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cur = null;

    // Opnieuw zoeken als Horizon (morph bij filteren) het spoor heeft vervangen
    function trackOf(g) {
      var t = g.__lvT;
      if (!t || !g.contains(t)) t = g.__lvT = g.querySelector('.lv-ch');
      return t;
    }
    function firstImg(g) {
      return g.querySelector('slideshow-slide img');
    }
    function cleanSizes(s) {
      s = (s || '').replace(/^\s*auto\s*,\s*/, '').trim();
      return s || '50vw';
    }
    function withWidth(u, w) {
      return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
    }

    // Vak i vullen als het nog leeg is. Vak 0 krijgt een kopie van foto 1 met dezelfde URL (uit de cache).
    function ensure(g, i) {
      var t = trackOf(g);
      var s = t && t.children[i];
      if (!s || s.firstElementChild) return s;
      var f = firstImg(g);
      var im = document.createElement('img');
      im.decoding = 'async';
      im.draggable = false;
      if (i === 0) {
        if (!f) return s;
        im.alt = '';
        im.src = f.currentSrc || f.src;
      } else {
        var u = s.getAttribute('data-u');
        if (!u) return s;
        im.alt = s.getAttribute('data-a') || '';
        var set = f && f.getAttribute('srcset');
        var fw = 832;
        if (set) {
          var parts = set.split(',').map(function (p) {
            var w = parseInt((p.trim().split(/\s+/)[1] || ''), 10);
            return w ? withWidth(u, w) + ' ' + w + 'w' : '';
          }).filter(Boolean);
          if (parts.length) {
            im.sizes = cleanSizes(f.getAttribute('sizes'));
            im.srcset = parts.join(', ');
          }
          var m = (f.currentSrc || '').match(/[?&]width=(\d+)/);
          if (m) fw = m[1];
        }
        im.src = withWidth(u, fw);
      }
      s.appendChild(im);
      return s;
    }

    function count(g) {
      var t = trackOf(g);
      return t ? t.children.length : 0;
    }
    function go(g, i, smooth) {
      var t = trackOf(g);
      if (!t) return;
      var n = count(g);
      i = Math.max(0, Math.min(n - 1, i));
      ensure(g, i);
      ensure(g, i + 1);
      g.__lvI = i;
      t.scrollTo({ left: i * t.clientWidth, behavior: smooth && !still.matches ? 'smooth' : 'auto' });
    }

    // Desktop: hover toont foto 2, horizontaal scrollen wisselt
    var acc = 0, lastT = 0, lastH = 0, lastAbs = 0, stepT = 0, locked = false;
    function onWheel(e) {
      var g = cur;
      if (!g) return;
      var dx = e.deltaX, dy = e.deltaY;
      if (e.shiftKey && !dx) { dx = dy; dy = 0; }
      if (e.deltaMode === 1) { dx *= 16; dy *= 16; }
      var now = e.timeStamp, ax = Math.abs(dx), ay = Math.abs(dy);
      var inGesture = now - lastH < 120;
      // Alleen als horizontaal duidelijk overheerst; anders scrolt de pagina gewoon
      if (!(ax > 2 && ax > ay * 1.5) && !(inGesture && ax >= ay)) return;
      e.preventDefault();
      var gap = now - lastT;
      lastT = now;
      lastH = now;
      if (locked) {
        // Een veeg is een foto: pas los na een pauze of een duidelijk nieuwe veeg (na het uitlopen)
        if (gap > 160 || (now - stepT > 320 && ax > lastAbs * 1.6 + 6)) { locked = false; acc = 0; }
        else { lastAbs = ax; return; }
      }
      if (gap > 160) acc = 0;
      acc += dx;
      lastAbs = ax;
      if (Math.abs(acc) >= 30) {
        go(g, (g.__lvI || 0) + (acc > 0 ? 1 : -1), true);
        locked = true;
        stepT = now;
        acc = 0;
      }
    }

    function enter(g) {
      cur = g;
      clearTimeout(g.__lvR);
      clearTimeout(g.__lvP);
      ensure(g, 0);
      var s = ensure(g, 1);
      go(g, 1, false);
      var im = s && s.querySelector('img');
      if (!im || (im.complete && im.naturalWidth)) g.classList.add('is-lv');
      else im.addEventListener('load', function () { if (cur === g) g.classList.add('is-lv'); }, { once: true });
      // Blijft de muis staan, dan alvast foto 3
      g.__lvP = setTimeout(function () { if (cur === g) ensure(g, 2); }, 500);
      g.__lvC = g.closest('product-card, .product-card') || g;
      g.__lvC.addEventListener('wheel', onWheel, { passive: false });
      acc = 0; locked = false;
    }
    function leave(g) {
      if (cur === g) cur = null;
      (g.__lvC || g).removeEventListener('wheel', onWheel);
      g.classList.remove('is-lv');
      clearTimeout(g.__lvP);
      g.__lvR = setTimeout(function () { if (cur !== g) go(g, 0, false); }, 220);
    }

    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse' || !fine.matches) return;
      // De hele kaart telt (foto en tekst eronder)
      var c = e.target.closest ? e.target.closest('product-card, .product-card') : null;
      var g = c ? c.querySelector('.card-gallery.lv-chg') : null;
      if (g === cur) return;
      if (cur) leave(cur);
      if (g) enter(g);
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      if (cur && !e.relatedTarget) leave(cur);
    }, { passive: true });

    // De volgende foto laden als het spoor verschuift (vegen, wisselen)
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('lv-ch')) return;
      var g = t.closest('.card-gallery.lv-chg');
      if (!g || !t.clientWidth) return;
      var i = Math.round(t.scrollLeft / t.clientWidth);
      if (i !== g.__lvI) g.__lvI = i;
      ensure(g, i);
      ensure(g, i + 1);
      g.classList.add('lv-mv');
      clearTimeout(g.__lvM);
      g.__lvM = setTimeout(function () { g.classList.remove('lv-mv'); }, 200);
    }, { capture: true, passive: true });

    function prep(g) {
      ensure(g, 0);
      ensure(g, 1);
    }
    // Touch: de foto volgt de vinger; bij loslaten een foto verder of terug
    var drag = null, swallow = 0;
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !e.isPrimary) return;
      var g = e.target.closest ? e.target.closest('.card-gallery.lv-chg') : null;
      var t = g && trackOf(g);
      if (!t || !t.clientWidth) return;
      prep(g);
      drag = { g: g, t: t, id: e.pointerId, x: e.clientX, y: e.clientY, s: t.scrollLeft, w: t.clientWidth, dir: 0, lx: e.clientX, lt: e.timeStamp, v: 0 };
    }, { capture: true, passive: true });
    document.addEventListener('pointermove', function (e) {
      var d = drag;
      if (!d || e.pointerId !== d.id) return;
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (!d.dir) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        // Vooral verticaal: de pagina scrolt, de kaart doet niets
        if (Math.abs(dx) <= Math.abs(dy)) { drag = null; return; }
        d.dir = 1;
        d.g.classList.add('lv-mv');
        try { d.g.setPointerCapture(e.pointerId); } catch (_) {}
      }
      var max = (count(d.g) - 1) * d.w;
      d.t.scrollLeft = Math.max(0, Math.min(max, d.s - dx));
      var dt = e.timeStamp - d.lt;
      if (dt > 0) { d.v = (e.clientX - d.lx) / dt; d.lx = e.clientX; d.lt = e.timeStamp; }
    }, { capture: true, passive: true });
    function release(e, cancel) {
      var d = drag;
      if (!d || e.pointerId !== d.id) return;
      drag = null;
      if (d.dir !== 1) return;
      var i0 = Math.round(d.s / d.w), i = i0, dx = e.clientX - d.x;
      if (!cancel) {
        if (dx < -d.w * 0.18 || d.v < -0.35) i = i0 + 1;
        else if (dx > d.w * 0.18 || d.v > 0.35) i = i0 - 1;
      }
      go(d.g, i, true);
      swallow = Date.now() + 450;
      clearTimeout(d.g.__lvM);
      d.g.__lvM = setTimeout(function () { d.g.classList.remove('lv-mv'); }, 350);
    }
    document.addEventListener('pointerup', function (e) { release(e, false); }, { capture: true, passive: true });
    document.addEventListener('pointercancel', function (e) { release(e, true); }, { capture: true, passive: true });
    // Na een veeg geen klik (anders opent het item)
    document.addEventListener('click', function (e) {
      if (swallow && Date.now() < swallow && e.target.closest && e.target.closest('.product-card, product-card')) {
        e.preventDefault();
        e.stopPropagation();
      }
      swallow = 0;
    }, true);

    // Touch: foto 2 laden zodra de kaart bijna in beeld is, ook voor kaarten die later bijkomen
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (list) {
      list.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); prep(en.target); }
      });
    }, { rootMargin: '300px 0px' }) : null;
    var queued = false;
    function scan() {
      queued = false;
      if (!io || fine.matches) return;
      var gs = document.querySelectorAll('.card-gallery.lv-chg:not([data-lv-o])');
      for (var k = 0; k < gs.length; k++) { gs[k].setAttribute('data-lv-o', ''); io.observe(gs[k]); }
    }
    function queue() {
      if (!queued) { queued = true; requestAnimationFrame(scan); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
    else queue();
    new MutationObserver(function (muts) {
      for (var k = 0; k < muts.length; k++) if (muts[k].addedNodes.length) { queue(); return; }
    }).observe(document.documentElement, { childList: true, subtree: true });
    if (fine.addEventListener) fine.addEventListener('change', queue);
  })();
  } catch(e) { console.error(e); }
})();

})();
